import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["startedAt", "endedAt", "workHours"]

  connect() {
    this.update()
  }

  update() {
    if (!this.hasStartedAtTarget || !this.hasEndedAtTarget || !this.hasWorkHoursTarget) return
    if (this.workHoursTarget.value && this.workHoursTarget.dataset.autoCalculated !== "true") return

    const startedAt = this.parseDateTime(this.startedAtTarget.value)
    const endedAt = this.parseDateTime(this.endedAtTarget.value)
    if (!startedAt || !endedAt || endedAt < startedAt) return

    const hours = (endedAt - startedAt) / 1000 / 60 / 60
    const value = this.formatHours(hours)
    this.workHoursTarget.value = value
    this.workHoursTarget.dataset.autoCalculated = "true"
    this.workHoursTarget.dataset.autoCalculatedValue = value
  }

  markManual() {
    if (this.workHoursTarget.value === this.workHoursTarget.dataset.autoCalculatedValue) return

    delete this.workHoursTarget.dataset.autoCalculated
    delete this.workHoursTarget.dataset.autoCalculatedValue
  }

  parseDateTime(value) {
    if (!value) return null

    const date = new Date(value)
    if (Number.isNaN(date.getTime())) return null

    return date
  }

  formatHours(hours) {
    return (Math.round(hours * 100) / 100).toString()
  }
}
